module.exports = {"510603001":"旌阳街道","510603004":"旌东街道","510603006":"八角井街道","510603009":"东湖街道","510603010":"天元街道","510603011":"孝感街道","510603100":"黄许镇","510603101":"孝泉镇","510603103":"柏隆镇","510603108":"德新镇","510603110":"双东镇","510603111":"新中镇","510603117":"和新镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510603.json
// module id = 2423
// module chunks = 0